module.exports = __webpack_public_path__ + "public/SiteIcons/payment-icons.png?1867bf28";